import BaseAPI from './base.api';

export default class NavigationMapAPI extends BaseAPI {
  async getNavigationMap(payload: any) {
    const response = await this.API.post('/navigation-map', payload);

    return response.data;
  }

  async createNavigationMap(payload: any) {
    const response = await this.API.post('/navigation-map/create', payload);
    return response.data;
  }
}
